import en from 'vee-validate/dist/locale/en.json';

export default {
  validate: (value, { other }) => {
    return other.map(s => s.toString()).includes(value.toString());
  },
  params: ['other'],
  message: `${en.messages.is}.`,
};
